import { isCapabilityEnabled } from "owa-capabilities";
import { newHeaderCapability } from "owa-capabilities-definitions/lib/newHeaderCapability";
import { isDrawerPaneVisible } from "owa-drawer";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isFlexPaneShown } from "../selectors/isFlexPaneShown";
import { DEFAULT_FLEXPANE_WIDTH } from "../utils/constants";

// The Copilot BizChat side pane is a special pane that requires a higher than usual default width.
// This value should match the one in owa-copilot-chat/*/constants.ts package.
const CHAT_COPILOT_BIZCHAT_DEFAULT_WIDTH = 380;
const CHAT_COPILOT_FLEXPANE_ID = "ChatCopilot";

/**
 * Returns the default flex pane width.
 * Normally, this should be DEFAULT_FLEXPANE_WIDTH (320) however Chat BizChat SidePane is special,
 * and has a wider-than-normal default width. Thus, we must check whether that's the pane that's being shown.
 *
 * @param flexPaneId: Optional parameter, if supplied will specifically check if that flexPaneId == ChatCopilot
 *                    Otherwise, will default to isFlexPaneShown
 */
export function getDefaultFlexPaneWidth(flexPaneId?: string): number {
    if (!isGlobalFeatureEnabled("mon-copilot-bizchat")) {
        return DEFAULT_FLEXPANE_WIDTH;
    }
    
    const isCopilotBizChat = isCopilotBizChatPane(flexPaneId);
    
    return isCopilotBizChat ? CHAT_COPILOT_BIZCHAT_DEFAULT_WIDTH : DEFAULT_FLEXPANE_WIDTH;
}

function isCopilotBizChatPane(flexPaneId?: string): boolean {
    const isNewHeaderEnabled = isCapabilityEnabled(newHeaderCapability);
    
    if (flexPaneId) {
        return isNewHeaderEnabled
            ? flexPaneId === "owa-app-pane-chatCopilot"
            : flexPaneId === CHAT_COPILOT_FLEXPANE_ID;
    }
    
    return isNewHeaderEnabled
        ? isDrawerPaneVisible("owa-app-pane-chatCopilot")
        : isFlexPaneShown(CHAT_COPILOT_FLEXPANE_ID);
}
